export default __webpack_public_path__ + "static/media/solar.d956cb97.png";